import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { LanguageService } from '../../../shared/services/language.service';
import { UserService } from '../../../shared/services/user.service';
import { ProductionStatusService } from '../_api/services/production-status-service';

let self: PublicReportComponent = null;
@Component({
  selector: 'app-public-report',
  templateUrl: './public-report.component.html',
  styleUrls: ['./public-report.component.css']
})
export class PublicReportComponent implements OnInit {

  selectedLanguageId = 1;
  languages = null;
  currentReportRefreshFunction = null;

  refreshTimeoutHandle: number = null;
  selectedReportId: number = null;

  customReport1ReportReportElementId: number = null;
  customReport2ReportId: number = null;
  productionStatusReportId: number = null;

  customReport2ReportIdBackup: number = null;
  customReport2ReportReportElementId: number = null;

  popupVisible = false;
  reports = null;

  constructor(private route: ActivatedRoute, private ds: ProductionStatusService, public ls: LanguageService, private us: UserService) {
    self = this;
    this.selectedReportId = null;
    this.customReport1ReportReportElementId = null;
    this.customReport2ReportId = null;
    this.customReport2ReportIdBackup = null;
    this.productionStatusReportId = null;
    this.customReport2ReportReportElementId = null;

    const lsData = this.getLocalStorageData();
    if (lsData !== null) {
      this.selectedLanguageId = lsData.languageId;
    }

    this.route.queryParams.subscribe(params => {
      
      let crp1id = params["customReport1ReportReportElementId"];
      if (typeof (crp1id) !== "undefined") {
        crp1id = crp1id?.trim();
        if (crp1id !== null) {
          this.customReport1ReportReportElementId = parseInt(crp1id);
          this.selectedReportId = ((-1) * this.customReport1ReportReportElementId);
        }
      }

      let crp2id = params["customReport2ReportId"];
      if (typeof (crp2id) !== "undefined") {
        crp2id = crp2id?.trim();
        if (crp2id !== null) {
          this.customReport2ReportId = parseInt(crp2id);
          this.selectedReportId = this.customReport2ReportId;
        }
      }

      let psrid = params["productionStatusReportId"];
      if (typeof (psrid) !== "undefined") {
        psrid = psrid?.trim();
        if (psrid !== null) {
          this.productionStatusReportId = parseInt(psrid);
          this.selectedReportId = this.productionStatusReportId;
        }
      }
      
      if (this.selectedReportId !== null) {
        this.setLocalStorageData();
        const currentUrl = window.location.href;
        const ix = currentUrl.indexOf("?");
        if (ix > 0) {
          //strip off query parameters and reload page
          window.location.href = currentUrl.substring(0, ix);
          return;
        }
      }
      else {
        if (lsData !== null) {
          this.customReport1ReportReportElementId = lsData.customReport1ReportReportElementId;
          if (this.customReport1ReportReportElementId > 0) {
            this.selectedReportId = ((-1) * this.customReport1ReportReportElementId);
          }
          else {
            this.customReport2ReportId = lsData.customReport2ReportId;
            if (this.customReport2ReportId > 0) {
              this.selectedReportId = this.customReport2ReportId;
            }
            else {
              this.productionStatusReportId = lsData.productionStatusReportId;
              if (this.productionStatusReportId > 0) {
                this.selectedReportId = this.productionStatusReportId;
              }
            }
          }
        }
      }
    });
    this.getLanguageTagTexts(this.selectedLanguageId);
  }

  private setLocalStorageData() {
    const lsData = {
      languageId: this.selectedLanguageId,
      customReport1ReportReportElementId: this.customReport1ReportReportElementId,
      customReport2ReportId: this.customReport2ReportId,
      productionStatusReportId: this.productionStatusReportId,
    };
    localStorage.setItem("diRect.Public.report.data", JSON.stringify(lsData));
  }

  private getLocalStorageData() {
    let theData = null;
    let lsJsonData = localStorage.getItem("diRect.Public.report.data");
    if (lsJsonData !== null) {
      lsJsonData = lsJsonData.trim();
      if (lsJsonData.length > 0) {
        theData = JSON.parse(lsJsonData);
      }
    }
    return theData;
  }

  ngOnInit() {
  }

  refresh() {
    //TODO maybe do something here??
  }

  languageDispExpr(e) {
    if (e !== null) {
      return `${e.Code} - ${e.Description}`;
    }
  }

  refreshCallbackChanged(e) {
    if (this.refreshTimeoutHandle > 0) {
      clearTimeout(this.refreshTimeoutHandle);
      this.refreshTimeoutHandle = null;
      this.currentReportRefreshFunction = null;
    }

    if (e !== null && e.sleepTimeInMilliSeconds > 0) {
      this.currentReportRefreshFunction = e.refreshFunction;
      this.refreshTimeoutHandle = setTimeout(function () {
        self.refreshTimeoutHandle = null;
        this.currentReportRefreshFunction = null;
        e.refreshFunction();
      }, e.sleepTimeInMilliSeconds) as any;
    }
  }

  languageItemClick(e) {
    this.selectedLanguageId = e.itemData.LanguageId;
    this.setLocalStorageData();
    this.getLanguageTagTexts(this.selectedLanguageId);
  }

  async getLanguageTagTexts(languageId: number) {
    await this.ds.getLanguageTagTexts(languageId).subscribe((res) => {
      this.us.setLanguageTagTexts(res.Data, languageId);
      if (typeof (this.currentReportRefreshFunction) === "function") {
        this.currentReportRefreshFunction();
      }
    });
  }

  customReport2ReportReportElementIdChanged(reportReportElement) {
    if (this.refreshTimeoutHandle > 0) {
      clearTimeout(this.refreshTimeoutHandle);
      this.refreshTimeoutHandle = null;
    }
    this.customReport2ReportIdBackup = this.customReport2ReportId;
    this.customReport1ReportReportElementId = null;
    this.customReport2ReportId = null;
    this.productionStatusReportId = null;
    this.customReport2ReportReportElementId = reportReportElement.ReportReportElementId;
  }

  closeCustomReport2Details() {
    if (this.refreshTimeoutHandle > 0) {
      clearTimeout(this.refreshTimeoutHandle);
      this.refreshTimeoutHandle = null;
    }
    this.customReport1ReportReportElementId = null;
    this.customReport2ReportId = this.customReport2ReportIdBackup;
    this.productionStatusReportId = null;
    this.customReport2ReportReportElementId = null;
    this.customReport2ReportIdBackup = null;
  }

  popupOnShowing(e) {
    this.ds.getPubliclyAvailableReports().subscribe((data) => {
      this.reports = data;
    });
    if (this.languages === null) {
      this.us.getLanguages().subscribe((res) => {
        if (res !== null && res.IsSuccess) {
          this.languages = res.Data;
        }
      });
    }
  }

  popupOnHiding(e) {
    this.reports = null;
  }

  gridOnContentReady(e) {
    const selReportIds = e.component.getSelectedRowKeys();
    if (selReportIds.length === 0) {
      e.component.selectRows([this.selectedReportId]);
    }
  }

  gridOnRowClick(e) {
    if (e.rowType !== "data")
      return;

    if (this.refreshTimeoutHandle > 0) {
      clearTimeout(this.refreshTimeoutHandle);
      this.refreshTimeoutHandle = null;
      this.currentReportRefreshFunction = null;
    }

    switch (e.data.CustomElementNumber) {
      case 0:
        this.customReport1ReportReportElementId = null;
        this.customReport2ReportId = null;
        this.productionStatusReportId = e.data.ReportId;
        this.selectedReportId = e.data.ReportId;
        break;
      case 1:
        this.customReport1ReportReportElementId = (-1) * e.data.ReportId;
        this.customReport2ReportId = null;
        this.productionStatusReportId = null;
        this.selectedReportId = e.data.ReportId;
        break;
      case 2:
        this.customReport1ReportReportElementId = null;
        this.customReport2ReportId = e.data.ReportId;
        this.productionStatusReportId = null;
        this.selectedReportId = e.data.ReportId;
        break;
      default:
        notify("Unknown CustomElementNumber=" + e.data.CustomElementNumber, "error", 5000);
        this.customReport1ReportReportElementId = null;
        this.customReport2ReportId = null;
        this.productionStatusReportId = null;
        this.selectedReportId = null;
        break;
    }

    if (this.selectedReportId !== null) {
      this.setLocalStorageData();
    }
    else {
      localStorage.removeItem("diRect.Public.report.data");
    }
    this.popupVisible = false;
  }

  getGroupByText(d) {
    let data = null;

    if (typeof (d.items) !== "undefined" && d.items !== null && d.items.length > 0) {
      data = d.items[0];
    }
    else {
      data = d.collapsedItems[0];
    }
    if (data.CustomElementNumber == 0) {
      return this.ls.LNG('Label.ProductionStatus');
    }
    else {
      return data.Type;
    }
  }
}
